export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'prod_SukQmcoBQOYD1K',
    priceId: 'price_1RyuvvBcRD18s6qSCoPwYfI7',
    name: 'Mystara AI PRO',
    description: 'Unlimited access to Mystara\'s full manifestation toolkit — including vision boards, ritual scheduler, oracle cards, journaling mentor, daily frequency readings, and unlimited chat guidance.',
    mode: 'subscription'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};

export const getProductById = (id: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.id === id);
};